import { Fragment } from 'vue-frag';
import { formatPrice } from 'utils/general';
import {
  trackProductClick,
  buildItemTrackingData,
  setLocalStorageProperties,
} from 'lib/tracking';

export default {
  props: ['heading', 'products'],
  components: {
    'vue-image': () => import('../vue-image/vue-image.vue'),
    Fragment,
  },
  methods: {
    formatPrice,
    handleTracking(product, index) {
      const otherData = {
        origin: document.body.dataset.origin,
        originProduct: document.body.dataset.originProduct,
        index,
      };

      const listData = {
        listName: this.heading,
        listId: 'compare-product',
        index,
        moduleName: 'compare heading'
      };

      const productObject = product;

      const itemObject = buildItemTrackingData(productObject, 1, otherData);

      if (
        productObject.isBundle ||
        productObject.metafields?.accentuate?.bundled_products
      ) {
        otherData.bundleName = productObject.title;
        otherData.bundleId = productObject.id;
        listData.bundleName = productObject.title;
        listData.bundleId = productObject.id;
      }

      setLocalStorageProperties(otherData, listData);
      trackProductClick('select_item', itemObject, listData);

      setTimeout(() => {
        window.location = product.url;
      }, 800);
    },
  },
  template: `
    <fragment>
      <h2 class="section-heading product-compare__heading" v-text="heading"></h2>
      <div class="product-compare__product-top" :class="{'product-compare__product-top--first': index === 0}" v-for="(product, index) in products">
        <a :href="product.url" @click.prevent="handleTracking(product, index)">
          <div class="product-compare__image-wrapper">
            <vue-image
              :full-width="true"
              fit="cover"
              :src="product.featuredImage"
              :alt="product.title"
              :lazy="true"
              width="205px"
              height="256px"
            >
            </vue-image>
          </div>
        </a>
        <a :href="product.url">
          <h3 class="product-compare__product-title bold uppercase p1" v-text="product.title"></h3>
        </a>
        <p
          class="product-compare__product-price OneLinkNoTx h6"
          v-text="formatPrice(product.price)"
        >
        </p>
      </div>
    </fragment>
  `,
};
